module.exports = __webpack_public_path__ + "img/empty2.ce3d512b.png";